import React from 'react';
import AuditLogDataComponent from './audit-log-data.component';
export default function AuditLogData() {
    return <AuditLogDataComponent />;
}
